import React, { useState } from 'react';
import axios from 'axios';
import config from '../config';

const TestAuth = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const testJWT = async () => {
    setLoading(true);
    setResult(null);

    console.log('=== TESTING JWT DEBUG ===');
    
    const token = localStorage.getItem('token');
    
    try {
      console.log('Making request to JWT debug endpoint...');
      
      const response = await axios.get(`${config.API_BASE_URL}/debug/jwt`, {
        headers: token ? {
          'Authorization': `Bearer ${token}`
        } : {}
      });
      
      console.log('✅ JWT Debug response:', response.data);
      setResult({
        success: true,
        data: response.data,
        type: 'jwt-debug'
      });
    } catch (error) {
      console.error('❌ JWT Debug error:', error);
      
      setResult({
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status,
        type: 'jwt-debug'
      });
    } finally {
      setLoading(false);
    }
  };

  const testInventory = async () => {
    setLoading(true);
    setResult(null);

    console.log('=== TESTING INVENTORY ACCESS ===');
    
    const token = localStorage.getItem('token');
    console.log('Token from localStorage:', token ? 'Present' : 'Missing');
    
    if (!token) {
      setResult({
        success: false,
        error: 'No token found in localStorage. Please login first.'
      });
      setLoading(false);
      return;
    }

    try {
      console.log('Making request to:', `${config.API_BASE_URL}/inventory`);
      console.log('With token:', token.substring(0, 20) + '...');
      
      const response = await axios.get(`${config.API_BASE_URL}/inventory`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      console.log('✅ Inventory response:', response.data);
      setResult({
        success: true,
        data: response.data,
        count: response.data.length
      });
    } catch (error) {
      console.error('❌ Inventory error:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      
      setResult({
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status
      });
    } finally {
      setLoading(false);
    }
  };

  const checkToken = () => {
    const token = localStorage.getItem('token');
    const merchant = localStorage.getItem('merchant');
    
    console.log('=== TOKEN CHECK ===');
    console.log('Token present:', !!token);
    console.log('Token length:', token?.length);
    console.log('Merchant data:', merchant);
    
    if (token) {
      try {
        // Decode JWT payload (not verifying signature, just reading)
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('Token payload:', payload);
        console.log('Token expires:', new Date(payload.exp * 1000));
        console.log('Token issued:', new Date(payload.iat * 1000));
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
  };

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Authentication Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={checkToken}
          style={{
            padding: '10px 20px',
            backgroundColor: '#17a2b8',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginRight: '10px'
          }}
        >
          Check Token
        </button>
        
        <button
          onClick={testJWT}
          disabled={loading}
          style={{
            padding: '10px 20px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            marginRight: '10px'
          }}
        >
          {loading ? 'Testing...' : 'Test JWT Debug'}
        </button>
        
        <button
          onClick={testInventory}
          disabled={loading}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Testing...' : 'Test Inventory Access'}
        </button>
      </div>

      {result && (
        <div style={{
          marginTop: '20px',
          padding: '20px',
          backgroundColor: result.success ? '#d4edda' : '#f8d7da',
          border: `1px solid ${result.success ? '#c3e6cb' : '#f5c6cb'}`,
          borderRadius: '8px'
        }}>
          <h3 style={{ 
            color: result.success ? '#155724' : '#721c24',
            marginTop: 0 
          }}>
            {result.success ? '✅ Success!' : '❌ Error'}
          </h3>
          
          {result.type === 'jwt-debug' ? (
            <>
              <h4>JWT Configuration Status:</h4>
              <ul style={{ textAlign: 'left', marginBottom: '15px' }}>
                <li><strong>JWT Secret Configured:</strong> {result.data?.jwtSecretConfigured ? '✅ Yes' : '❌ No'}</li>
                <li><strong>JWT Secret Length:</strong> {result.data?.jwtSecretLength || 0} characters</li>
                <li><strong>Token Provided:</strong> {result.data?.tokenProvided ? '✅ Yes' : '❌ No'}</li>
                <li><strong>Token Valid:</strong> {result.data?.tokenValid ? '✅ Yes' : '❌ No'}</li>
                {result.data?.tokenPayload && (
                  <>
                    <li><strong>Merchant ID:</strong> {result.data.tokenPayload.merchantId}</li>
                    <li><strong>Token Expires:</strong> {result.data.tokenPayload.expiresAt}</li>
                    <li><strong>Is Expired:</strong> {result.data.tokenPayload.isExpired ? '❌ Yes' : '✅ No'}</li>
                  </>
                )}
                {result.data?.tokenError && (
                  <li><strong>Token Error:</strong> {result.data.tokenError.name} - {result.data.tokenError.message}</li>
                )}
              </ul>
              <details>
                <summary>View Full Debug Data</summary>
                <pre style={{ 
                  backgroundColor: '#fff', 
                  padding: '15px', 
                  borderRadius: '4px',
                  overflow: 'auto',
                  marginTop: '10px'
                }}>
                  {JSON.stringify(result.data, null, 2)}
                </pre>
              </details>
            </>
          ) : result.success ? (
            <>
              <p><strong>Inventory Items:</strong> {result.count}</p>
              <details>
                <summary>View Data</summary>
                <pre style={{ 
                  backgroundColor: '#fff', 
                  padding: '15px', 
                  borderRadius: '4px',
                  overflow: 'auto',
                  marginTop: '10px'
                }}>
                  {JSON.stringify(result.data, null, 2)}
                </pre>
              </details>
            </>
          ) : (
            <>
              <p><strong>Status Code:</strong> {result.status}</p>
              <pre style={{ 
                backgroundColor: '#fff', 
                padding: '15px', 
                borderRadius: '4px',
                overflow: 'auto'
              }}>
                {JSON.stringify(result.error, null, 2)}
              </pre>
            </>
          )}
        </div>
      )}

      <div style={{ 
        marginTop: '30px', 
        padding: '20px', 
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '8px'
      }}>
        <h3 style={{ marginTop: 0 }}>Instructions:</h3>
        <ol>
          <li><strong>First:</strong> Click "Test JWT Debug" to check JWT configuration</li>
          <li>Make sure you're logged in first</li>
          <li>Click "Check Token" to verify token is stored locally</li>
          <li>Click "Test Inventory Access" to test protected route</li>
          <li>Check Debug Console for detailed logs</li>
          <li>Open browser DevTools (F12) to see all logs</li>
        </ol>
        
        <div style={{ 
          marginTop: '20px', 
          padding: '15px', 
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px'
        }}>
          <h4 style={{ marginTop: 0, color: '#495057' }}>Common Issues & Solutions:</h4>
          <ul style={{ marginBottom: 0, textAlign: 'left' }}>
            <li><strong>JWT Secret Not Configured:</strong> Set JWT_SECRET on Render</li>
            <li><strong>Invalid Token Signature:</strong> JWT_SECRET mismatch - logout and login again</li>
            <li><strong>Token Expired:</strong> Login again to get fresh token</li>
            <li><strong>403 Errors:</strong> Usually JWT_SECRET issue on server</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestAuth;